import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  TablePagination,
  Button,
  Typography,
  TableFooter,
} from "@mui/material";
import isGHMC, { getCurrentDate, getCurrentDateTime, getStartOfCurrentDate } from "../../../Common/helper/helpar";
import { useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import { AllDeploymentSummaryReport } from "../../../Apis/userCreationApi";
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import CreatableSelect from "react-select/creatable";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import { TableLoader } from "../../../Common/ShimmerLoader";
const DeploymentSummaryReport = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [startDate, setStartDate] = useState(getCurrentDateTime());
  const [transferStationName, setTransferStationName] = useState("");
  const [endDate, setEndDate] = useState("");
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const [shiftType, setShiftType] = useState([]);
  const currentDateTime = getCurrentDateTime();
  const [fromDate, setFromDate] = useState(getStartOfCurrentDate());
  const [toDate, setToDate] = useState(currentDateTime);
  const [formInput, setFormInput] = useState({
    shiftId: 1,
  });
  const isProd = isGHMC();

  // Fetch data from new API
  //  fetchData(formInput.shiftId, startDate, transferStationName, selectedOwnerType, selectedVehicleType);
  const fetchData = async (
    shiftId,
    fromDate,
    toDate,
    transferStationName,
    selectedOwnerType,
    selectedVehicleType
  ) => {
    setIsLoading(true)
    try {
      const data = await AllDeploymentSummaryReport(
        shiftId,
        fromDate,
        toDate,
        transferStationName,
        selectedOwnerType,
        selectedVehicleType
      );
      setRows(data);
      setFilteredRows(data); // Update filtered rows as well
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false)
    }
  };
  const fetchShiftData = async () => {
    try {
      const response = await AllShiftMaster();
      setShiftType(response);
    } catch (error) {
      console.log(error);
    }
  };
  // Call fetchData when the component mounts
  useEffect(() => {
    fetchShiftData();
    fetchData(formInput.shiftId, fromDate,toDate);
  }, []);

  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchOwnerTypeData();
  }, []);

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);

  useEffect(() => {
    setOptionsValues(
      ownerTypeDetails
        .filter((ownerType) => ownerType.isActive)
        .map((ownerType) => ({
          value: ownerType.ownerTypeId,
          label: ownerType.ownerTypeName,
        }))
    );
  }, [ownerTypeDetails]);

  useEffect(() => {
    setVehicleTypeOptionsValues(
      vehicleTypeDetails.map((vehicleType) => ({
        value: vehicleType.vehicleTypeId,
        label: vehicleType.vehicleTypeName,
      }))
    );
  }, [vehicleTypeDetails]);

  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      setSelectedOwnerType(newValue.value);
    } else if (actionMeta.action === "create-option") {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedOwnerType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === "clear") {
        setSelectedOwnerType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === "create-option") {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === "clear") {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  // Function to handle filter button click
  const handleFilter = () => {
   
    fetchData(
      formInput.shiftId,
      fromDate,
      toDate,
      transferStationName,
      selectedOwnerType,
      selectedVehicleType
    ); // Call API with selected shift ID and dates and transferStationName
  };

  localStorage.setItem("selectedOwnerType", selectedOwnerType);
  localStorage.setItem("selectedVehicleType", selectedVehicleType);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 100));
    setPage(0);
  };

  const handleShiftChange = (e) => {
    const selectedShift = e.target.value;
   
    setFormInput({
      ...formInput,
      shiftId: selectedShift,
    });
  };

  const shiftMapping = {
    morning: "1",
    afternoon: "2",
    evening: "3",
  };

  const innerReportTS = (row) => {
    navigate("/inner-teritory-deployedts", { state: row });
  };

  const innerReportJN = (row) => {
    navigate("/inner-teritory-deployedJN", { state: row });
  };

  const innerReportHalting = (row) => {
    navigate("/inner-teritory-hatling-report", { state: row });
  };

  const innerReportTotalDeployment = (row) => {
    navigate("/inner-teritory-total-deployment", { state: row });
  };

  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Deployment Summary");

    const boldFont = { bold: true };

    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Deployment Summary Report Generated on: ${formattedDate}, ${formattedTime}`;

    // Add report timestamp
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Report title
    worksheet.addRow(["", "", "Deployment Summary Report", ""]);
    worksheet.mergeCells(2, 2, 2, 6);
    worksheet.getCell(2, 2).value = "Deployment Summary Report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Table headers
    const headers = [
      "S.No",
      "Zone Name",
      "Transfer Station Name",
      "Allotted Vehicles",
      "Deployed from TS/SCTP",
      "Deployed from JN",
      "Halting",
      "Total Deployment",
      "Not Deployed",
      "Deployment %",
    ];

    const tableHeaderRow = worksheet.addRow(headers);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" }, // Background color
      };
    });

    // Initialize total counts
    let totalAllottedVehicles = 0,
      totalDeployedFromTS_SCTP = 0,
      totalDeployedFromJN = 0,
      totalHalting = 0,
      totalDeployment = 0,
      totalNotDeployed = 0,
      totalDeploymentPercentage = 0;

    rows.forEach((item, index) => {
      totalAllottedVehicles += item.allottedVehicles || 0;
      totalDeployedFromTS_SCTP += item.deployedFromTS_SCTP || 0;
      totalDeployedFromJN += item.deployedFromJN || 0;
      totalHalting += item.halting || 0;
      totalDeployment += item.totalDeployment || 0;
      totalNotDeployed += item.notDeployed || 0;
      totalDeploymentPercentage += item.deploymentPercentage || 0;

      worksheet
        .addRow([
          index + 1,
          item.zoneName?? "N/A",
          item.transferStationName?? "N/A",
          item.allottedVehicles?? "N/A",
          item.deployedFromTS_SCTP?? "N/A",
          item.deployedFromJN?? "N/A",
          item.halting?? "N/A",
          item.totalDeployment?? "N/A",
          item.notDeployed?? "N/A",
          item.deploymentPercentage?? "N/A",
        ])
        .eachCell((cell) => {
          cell.alignment = { horizontal: "left" };
        });
    });

    // Calculate average deployment percentage
    const averageDeploymentPercentage =
      rows.length > 0
        ? (totalDeploymentPercentage / rows.length).toFixed(2)
        : "0.00";

    // Add Total Count Row
    const totalRow = worksheet.addRow([
      "Total",
      "",
      "",
      totalAllottedVehicles,
      totalDeployedFromTS_SCTP,
      totalDeployedFromJN,
      totalHalting,
      totalDeployment,
      totalNotDeployed,
      totalDeploymentPercentage, // Corrected total deployment percentage
    ]);

    totalRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" }, // Highlighted row
      };
    });

    // Set column widths
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 25 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
    ];

    // Save as file
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "DeploymentSummaryReport.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Deployment Summary Report</h4>
            <div className="card">
              <div className="card-body p-3">
                <div className="row align-items-end text-start">
                <div className="col-md-2">
                    <div>
                      <label className="form-label w-100 text-left">From Date</label>
                      <input
                      type="datetime-local"
                      id="FromDate"
                      name="FromDate"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      className="form-control"
                      max={toDate}
                    />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div>
                      <label className="form-label w-100 text-left">To Date</label>
                      <input
                        type="datetime-local"
                        id="ToDate"
                        name="ToDate"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className="form-control"
                        min={fromDate}
                        max={currentDateTime}
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-3">
                    <label>Report Date</label>
                    <input
                      label="Start Date"
                      type="date"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ marginRight: "20px" }}
                    />
                  </div> */}
                  <div className="col-md-2">
                    <label htmlFor="ownerType">Owner Type:</label>
                    <CreatableSelect
                      style={{ Height: "34px !important" }}
                      classNamePrefix="CreatableSelect"
                      inputId="ownerType"
                      name="ownerTypeId"
                      id="ownerType"
                      placeholder="Select"
                      options={optionsValues}
                      isClearable={true}
                      onChange={handleChange}
                      onCreateOption={(inputValue) => {
                        const newValue = {
                          label: inputValue,
                          value: inputValue.toLowerCase(),
                        };
                        {
                          inputValue && newValue
                            ? setSelectedOwnerType(newValue.value)
                            : setSelectedOwnerType("  ");
                        }
                        // setSelectedOwnerType(newValue.value);
                        // Add logic to update optionsValues with the new option if needed
                      }}
                      value={optionsValues.find(
                        (option) => option.value === selectedOwnerType
                      )}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="VehicleType">Vehicle Type:</label>
                    <CreatableSelect
                      style={{ Height: "34px !important" }}
                      classNamePrefix="CreatableSelect"
                      inputId="vehicleType"
                      name="vehicleTypeId"
                      id="vehicleType"
                      placeholder="Select"
                      options={vehicleTypeOptionsValues}
                      isClearable={true}
                      onChange={handleVehicleTypeChange}
                      onCreateOption={(inputValue) => {
                        const newValue = {
                          label: inputValue,
                          value: inputValue.toLowerCase(),
                        };
                        {
                          inputValue && newValue
                            ? setSelectedVehicleType(newValue.value)
                            : setSelectedVehicleType("  ");
                        }
                        // setSelectedOwnerType(newValue.value);
                        // Add logic to update optionsValues with the new option if needed
                      }}
                      value={vehicleTypeOptionsValues.find(
                        (option) => option.value === selectedVehicleType
                      )}
                    />
                  </div>
                  <div class="col-md-2">
                    <label htmlFor="ShiftId">Shift</label>
                    <select
                      className="form-select"
                      style={inputStyle2}
                      name="shiftName"
                      id="shiftName"
                      value={formInput.shiftId} // To set the correct option
                      onChange={handleShiftChange}
                    >
                      <option value={1}>
                        Morning
                      </option>
                      <option value={2}>
                        Evening
                      </option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>Transfer Station Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Transfer Station Name"
                      value={transferStationName}
                      onChange={(e) => setTransferStationName(e.target.value)}
                    />
                  </div>

                  {/* <TextField
                        label="End Date"
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ marginRight: '20px' }}
                      /> */}

                  <div className="col-md-12">
                    <div className="d-flex justify-content-end align-items-end">
                      <button
                        variant="contained"
                        className={`btn mt-4 ${
                          isProd ? "search-ghmc" : "search-swm"
                        }`}
                        onClick={handleFilter}
                        sx={{ padding: "10px 20px" }}
                      >
                        Search
                      </button>
                      <button
                        className="btn btn-excel"
                        onClick={downloadAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                        Excel
                      </button>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <Paper
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      marginTop: "20px",
                    }}
                  >
                    <TableContainer
                      component={Paper}
                      sx={{
                        width: "100%",
                        maxHeight: "500px", // Set a maximum height for the container
                        border: "1px solid #ccc",
                      }}
                    >
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead
                          className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                          sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 0,
                          }}
                        >
                          <TableRow sx={{ paddingTop: "20px" }}>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              S.No
                            </TableCell>
                            {/* <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', border: '1px solid #ddd' }}>Zone ID</TableCell> */}
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Zone Name
                            </TableCell>
                            {/* <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', border: '1px solid #ddd' }}>Transfer Station ID</TableCell> */}
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Transfer Station Name
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Allotted Vehicles
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Deployed from TS/SCTP
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Deployed from JN
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Halting
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Total Deployment
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Not Deployed
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRight: "none",
                                color: "#fff",
                                backgroundColor: isProd ? "#004554" : "#EC1117",
                              }}
                            >
                              Deployement %
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredRows.length > 0 ? (
                            filteredRows.map((row, index) => (
                              <TableRow
                                key={row.sno}
                                sx={{
                                  backgroundColor: index % 2 === 1 ? "rgba(0, 69, 84, 0.04)" : "#ffffff",
                                }}
                              >
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    padding: "10px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {row.sno || index + 1}
                                </TableCell>
                                {/* <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd' }}>{row.zoneID}</TableCell> */}
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    padding: "10px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {row.zoneName}
                                </TableCell>
                                {/* <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd' }}>{row.transferStationId}</TableCell> */}
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    padding: "10px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {row.transferStationName || "N/A"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {row.allottedVehicles}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => innerReportTS(row)}
                                >
                                  {row.deployedFromTS_SCTP}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => innerReportJN(row)}
                                >
                                  {row.deployedFromJN}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => innerReportHalting(row)}
                                >
                                  {row.halting}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    innerReportTotalDeployment(row)
                                  }
                                >
                                  {row.totalDeployment}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {row.notDeployed}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {row.deploymentPercentage}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={11}
                                sx={{ textAlign: "center" }}
                              >
                                No data available
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                        {filteredRows.length > 0 && (
                          <TableFooter>
                            <TableRow
                              sx={{
                                backgroundColor: "rgb(255, 237, 238)",
                                fontWeight: "bold",
                              }}
                            >
                              <TableCell
                                sx={{ textAlign: "center", color: "black" }}
                                colSpan={3}
                              >
                                Total
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  border: "1px solid #ddd",
                                  color: "black",
                                }}
                              >
                                {filteredRows.reduce(
                                  (sum, row) =>
                                    sum + (row.allottedVehicles || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  border: "1px solid #ddd",
                                  color: "black",
                                }}
                              >
                                {filteredRows.reduce(
                                  (sum, row) =>
                                    sum + (row.deployedFromTS_SCTP || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  border: "1px solid #ddd",
                                  color: "black",
                                }}
                              >
                                {filteredRows.reduce(
                                  (sum, row) => sum + (row.deployedFromJN || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  border: "1px solid #ddd",
                                  color: "black",
                                }}
                              >
                                {filteredRows.reduce(
                                  (sum, row) => sum + (row.halting || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  border: "1px solid #ddd",
                                  color: "black",
                                }}
                              >
                                {filteredRows.reduce(
                                  (sum, row) =>
                                    sum + (row.totalDeployment || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  border: "1px solid #ddd",
                                  color: "black",
                                }}
                              >
                                {filteredRows.reduce(
                                  (sum, row) => sum + (row.notDeployed || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  border: "1px solid #ddd",
                                  color: "black",
                                }}
                              >
                                {filteredRows.reduce(
                                  (sum, row) =>
                                    sum + (row.deploymentPercentage || 0),
                                  0
                                )}
                              </TableCell>{" "}
                              {/* Deployment % cannot be summed directly */}
                            </TableRow>
                          </TableFooter>
                        )}
                      </Table>
                    </TableContainer>
                    <TablePagination
                      component="div"
                      count={filteredRows.length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeploymentSummaryReport;

const inputStyle2 = {
  border: "1px solid #E2E2E2",
  borderRadius: "0px",
};
